var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPdfArrowCircleLeft = function SvgPdfArrowCircleLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2844 3.14978C8.28274 3.14977 2.60681 8.82571 2.60681 15.8273C2.60681 22.8289 8.28274 28.5049 15.2844 28.5049C22.286 28.5049 27.9619 22.8289 27.9619 15.8273C27.9619 8.82571 22.286 3.14978 15.2844 3.14978Z",
    fill: "#03C297"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8815 10.4012C17.1223 10.4012 17.3632 10.4899 17.5534 10.6801C17.921 11.0477 17.921 11.6563 17.5534 12.0239L13.7501 15.8272L17.5534 19.6304C17.921 19.9981 17.921 20.6066 17.5534 20.9743C17.1857 21.3419 16.5772 21.3419 16.2095 20.9743L11.7344 16.4991C11.3667 16.1314 11.3667 15.5229 11.7344 15.1553L16.2095 10.6801C16.3997 10.4899 16.6406 10.4012 16.8815 10.4012Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPdfArrowCircleLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pdf-arrow-circle-left.98611955.svg";
export { ForwardRef as ReactComponent };